import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PaceCoreModule } from '@evorait/pace-core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LetDirective, PushPipe } from '@ngrx/component';
import { SharedModule } from '../shared/shared.module';
import { ActionsComponent } from './actions/actions.component';
import { ContractInformationComponent } from './contract-information/contract-information.component';
import { ContractComponent } from './contract/contract.component';
import { CustomerComponent } from './customer/customer.component';
import { DataMaintenanceLocationComponent } from './data-maintenance/data-maintenance-location.component';
import { DataMaintenanceSysconfigComponent } from './data-maintenance/data-maintenance-sysconfig.component';
import { DetailsCarouselComponent } from './details-carousel/details-carousel.component';
import { EquipmentConfigurationServiceKeyComponent } from './equipment-configuration-service-key/equipment-configuration-service-key.component';
import { EquipmentConfigurationComponent } from './equipment-configuration/equipment-configuration.component';
import { EquipmentHistoryDetailComponent } from './equipment-history/equipment-history-detail/equipment-history-detail.component';
import { EquipmentHistoryComponent } from './equipment-history/equipment-history.component';
import { HeaderComponent } from './header/header.component';
import { InternalInfoComponent } from './internal-info/internal-info.component';
import { LongtextComponent } from './longtext/longtext.component';
import { ObjectInfoComponent } from './object-info/object-info.component';
import { OverviewComponent } from './overview/overview.component';
import { StatusStepButtonComponent } from './status-step-button/status-step-button.component';
import { TravelStatusUpdateComponent } from './travel-status-update/travel-status-update.component';
import { DataMaintenanceSysconfigExpandableComponent } from './data-maintenance/data-maintenance-sysconfig-expandable/data-maintenance-sysconfig-expandable.component';
import { PreclarificationComponent } from './longtext/preclarification/preclarification.component';
import { EquipmentConfigurationDetailComponent } from './equipment-configuration/equipment-configuration-detail/equipment-configuration-detail.component';
import { InternalInfoContactComponent } from './internal-info/internal-info-contact/internal-info-contact.component';
import { InternalInfoCategoryComponent } from './internal-info/internal-info-category/internal-info-category.component';
import { InternalInfoClosePopupComponent } from './internal-info/internal-info-close-popup/internal-info-close-popup.component';
import { EquipmentOtherTasksComponent } from './equipment-other-tasks/equipment-other-tasks.component';
import { OtherTasksListComponent } from './task-list/other-tasks-list.component';
import { PaceNotificationPreviewComponent } from '@evorait/pace-components';
import { CriticalityComponent } from './criticality/criticality.component';
import { OtherTasksExpandableRowComponent } from './task-list/other-tasks-list-expandable/other-tasks-expandable-row.component';
import { DurationComponent } from './duration/duration.component';
import { PCHDurationComponent } from './pch-duration/pch-duration.component';
import { PCHAlertComponent } from './pch-alert/pch-alert.component';

@NgModule({
    declarations: [
        EquipmentHistoryDetailComponent,
        TravelStatusUpdateComponent,
        OverviewComponent,
        HeaderComponent,
        StatusStepButtonComponent,
        LongtextComponent,
        DetailsCarouselComponent,
        ActionsComponent,
        ContractComponent,
        ObjectInfoComponent,
        CustomerComponent,
        CriticalityComponent,
        DurationComponent,
        ContractInformationComponent,
        EquipmentHistoryComponent,
        EquipmentConfigurationComponent,
        EquipmentConfigurationServiceKeyComponent,
        DataMaintenanceLocationComponent,
        DataMaintenanceSysconfigComponent,
        InternalInfoComponent,
        InternalInfoContactComponent,
        InternalInfoCategoryComponent,
        InternalInfoClosePopupComponent,
        DataMaintenanceSysconfigExpandableComponent,
        PreclarificationComponent,
        EquipmentConfigurationDetailComponent,
        EquipmentOtherTasksComponent,
        OtherTasksListComponent,
        OtherTasksExpandableRowComponent,
        PCHDurationComponent,
        PCHAlertComponent,
    ],
    imports: [
        CommonModule,
        FontAwesomeModule,
        SharedModule,
        PaceCoreModule.forChild(),
        LetDirective,
        PushPipe,
        PaceCoreModule,
        PaceNotificationPreviewComponent,
    ],
    exports: [HeaderComponent],
})
export class DetailsModule {}
